import React from 'react';
import {
  Container as TableContainer,
  Head as TableHead,
  HeadWrapper as TableHeadWrapper,
  Th as TableTh,
} from '#app/components/Table/styles';
import { OperationSizeConstants } from '../OperationSizeConstants';
import { TabSearch } from '#app/pages/IncomeAndExpenses/style';
import CategoryFilter from '#app/pages/IncomeAndExpenses/components/BaseOperationList/Filter/CategoryFilter';
import FilterDescriptionInput from '#app/pages/IncomeAndExpenses/components/BaseOperationList/Filter/FilterDescriptionInput';
import DateInputWrapperForPlaceholder from '#app/pages/IncomeAndExpenses/components/BaseOperationList/Filter/DateInputWrapperForPlaceholder';
import { useAppSelector } from '#app/hooks/useAppStore';
import InputWrapperForPlaceholder from '#app/pages/IncomeAndExpenses/components/BaseOperationList/Filter/InputWrapperForPlaceholder';

const search = require('#app/assets/icons/ic_seach_blue.svg');

const FilterForm = ({
  filterShow,
  chartShow,
  loadData,

  filterCategoryTypes,
  filterSubcategories,
  filterTags,
  filterAccounts,

  filterDateFrom,
  setFilterDateFrom,
  filterDateTo,
  setFilterDateTo,
  filterSumFrom,
  setFilterSumFrom,
  filterSumTo,
  setFilterSumTo,
  filterCategoryItems,
  setFilterCategoryItems,
  filterSubcategoryItems,
  setFilterSubcategoryItems,
  filterTagItems,
  setFilterTagItems,
  showFilterDesc,
  setShowFilterDesc,
  filterDesc,
  setFilterDesc,
  filterAccountItems,
  setFilterAccountItems,
}) => {
  const i18n = useAppSelector((state) => state.i18n);
  if (!filterShow) {
    return null;
  }

  return (
    <TableContainer>
      <TabSearch id="use-filter" className={chartShow ? '' : ''} onClick={loadData}>
        <img src={search} />
      </TabSearch>
      <TableHead>
        <TableHeadWrapper style={{ borderTop: 'none' }}>
          <TableTh flexWidth={'10%'} style={{ flexWrap: 'wrap' }}>
            <DateInputWrapperForPlaceholder
              id="date_from"
              value={filterDateFrom}
              onChange={setFilterDateFrom}
              placeholder={i18n.incomeOutcome.from}
            />
            <DateInputWrapperForPlaceholder
              id="date_to"
              value={filterDateTo}
              onChange={setFilterDateTo}
              placeholder={i18n.incomeOutcome.to}
            />
          </TableTh>
          <TableTh flexWidth={OperationSizeConstants.editCellWidth} style={{ flexWrap: 'wrap' }} />
          <TableTh flexWidth={OperationSizeConstants.sumCellWidth} style={{ flexWrap: 'wrap' }}>
            <InputWrapperForPlaceholder
              id="sum_from"
              value={filterSumFrom}
              onChange={setFilterSumFrom}
              placeholder={i18n.incomeOutcome.from}
            />
            <InputWrapperForPlaceholder
              id="sum_to"
              value={filterSumTo}
              onChange={setFilterSumTo}
              placeholder={i18n.incomeOutcome.to}
            />
          </TableTh>
          <TableTh
            flexWidth={OperationSizeConstants.categoryCellWidth}
            style={{ flexWrap: 'wrap' }}
          >
            <CategoryFilter
              options={filterCategoryTypes}
              items={filterCategoryItems}
              setItems={setFilterCategoryItems}
            />
          </TableTh>
          <TableTh
            flexWidth={OperationSizeConstants.subcategoryCellWidth}
            style={{ flexWrap: 'wrap' }}
          >
            <CategoryFilter
              options={filterSubcategories}
              items={filterSubcategoryItems}
              setItems={setFilterSubcategoryItems}
            />
          </TableTh>
          <TableTh flexWidth={OperationSizeConstants.tagCellWidth} style={{ flexWrap: 'wrap' }}>
            <CategoryFilter
              placeholder={''}
              options={filterTags}
              items={filterTagItems}
              setItems={setFilterTagItems}
            />
          </TableTh>
          <TableTh flexWidth={OperationSizeConstants.descCellWidth} style={{ flexWrap: 'wrap' }}>
            <FilterDescriptionInput
              showFilterDesc={showFilterDesc}
              setShowFilterDesc={setShowFilterDesc}
              filterDesc={filterDesc}
              setFilterDesc={setFilterDesc}
            />
          </TableTh>
          <TableTh flexWidth={OperationSizeConstants.accountCellWidth} style={{ flexWrap: 'wrap' }}>
            <CategoryFilter
              options={filterAccounts}
              items={filterAccountItems}
              setItems={setFilterAccountItems}
            />
          </TableTh>
        </TableHeadWrapper>
      </TableHead>
    </TableContainer>
  );
};

export default FilterForm;
